import { createPortal } from 'react-dom';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useState, useRef } from 'react';

export const ToolTip = ({ definitions, width = "w-80" }) => {
  const [hovered, setHovered] = useState(false);
  const ref = useRef(null);

  return (
    <div 
      className="inline-flex relative"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      ref={ref}
    >
      <InformationCircleIcon className="h-4 w-4 text-gray-500 cursor-help" />

      {hovered && createPortal(
        <div 
          className={`absolute bg-gray-900 text-white text-xs rounded-lg py-3 px-3 ${width} shadow-xl`}
          style={{
            top: ref.current?.getBoundingClientRect().bottom + window.scrollY + 8,
            left: ref.current?.getBoundingClientRect().left + window.scrollX,
            zIndex: 9999
          }}
        >
          {Object.entries(definitions).map(([key, value]) => (
            <div key={key} className="space-y-1">
              <span className="font-semibold">{key}:</span> {value}
            </div>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
};

export default ToolTip